import { META_REDUCERS } from '@ngrx/store';
import { provideStore, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '@env/environment';
import { loginReducer } from '@app/root-store/login-store/reducer';
import { ReportStoreEffects } from '@app/root-store/report-store/effects';
import { clearState } from '@app/root-store/root-store.module';
import { VaultReducer } from '@app/root-store/vault-store/reducer';
import { NotificationReducer } from '@app/root-store/notification-store/reducer';
import { ReportReducer } from '@app/root-store/report-store/reducer';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { NotificationStoreEffects } from '@app/root-store/notification-store/effects';
import { ChecklistStoreEffects } from '@app/root-store/checklist-store/effects';
import { MyInformationStoreEffects } from '@app/root-store/my-information-store/effects';
import { WorkspaceStoreEffects } from '@app/root-store/workspaces-store/effects';
import { FamilyTreeStoreEffects } from '@app/root-store/family-tree-store/effects';
import { RelationshipStoreEffects } from '@app/root-store/relationship-store/effects';
import { PermissionStoreEffects } from '@app/root-store/permission-store/effects';
import { ChatStoreEffects } from '@app/root-store/chat-store/effects';
import { checklistReducer } from '@app/root-store/checklist-store/reducer';
import { myInformationReducer } from '@app/root-store/my-information-store/reducer';
import { workspacesReducer } from '@app/root-store/workspaces-store/reducer';
import { familyTreeReducer } from '@app/root-store/family-tree-store/reducer';
import { RelationshipReducer } from '@app/root-store/relationship-store/reducer';
import { PermissionReducer } from '@app/root-store/permission-store/reducer';
import { chatReducer } from '@app/root-store/chat-store/reducer';

export const storeProviders = [
  provideStore({}),
  provideState('User', loginReducer),
  provideState('Vault', VaultReducer),
  provideState('Notification', NotificationReducer),
  provideState('Relationship', RelationshipReducer),
  provideState('Permissions', PermissionReducer),
  provideState('Checklist', checklistReducer),
  provideState('MyInformation', myInformationReducer),
  provideState('workspaces', workspacesReducer),
  provideState('Report', ReportReducer),
  provideState('chat', chatReducer),
  provideState('FamilyTree', familyTreeReducer),
  provideEffects([
    LoginStoreEffects,
    VaultStoreEffects,
    NotificationStoreEffects,
    ReportStoreEffects,
    ChecklistStoreEffects,
    MyInformationStoreEffects,
    WorkspaceStoreEffects,
    FamilyTreeStoreEffects,
    RelationshipStoreEffects,
    PermissionStoreEffects,
    ChatStoreEffects,
  ]),
  provideStoreDevtools({ maxAge: 25, logOnly: environment.production, connectInZone: true }),
  { provide: META_REDUCERS, useValue: clearState, multi: true },
];